module.exports = __webpack_public_path__ + "assets/img/sdwan-module8-2.d9f9c362.jpg";